import { render, staticRenderFns } from "./lenderLoanItem.vue?vue&type=template&id=53b4f8a0&scoped=true"
import script from "./lenderLoanItem.vue?vue&type=script&lang=js"
export * from "./lenderLoanItem.vue?vue&type=script&lang=js"
import style0 from "./lenderLoanItem.vue?vue&type=style&index=0&id=53b4f8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4f8a0",
  null
  
)

export default component.exports